import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentDashboardAnalyticsService } from '@payments/pages/payment-dashboard/tracking/analytics/payment-dashboard-analytics.service';
import { PaymentDashboardRowsComponent } from '../payment-dashboard-rows.component';

@Component({
  selector: 'app-account-activity-row-desktop',
  templateUrl: './account-activity-row-desktop.component.html',
  styleUrls: [
    '../payment-dashboard-rows.component.scss',
    './account-activity-row-desktop.component.scss',
  ],
})
export class AccountActivityRowDesktopComponent extends PaymentDashboardRowsComponent {
  constructor(
    readonly router: Router,
    protected paymentDashboardAnalytics: PaymentDashboardAnalyticsService,
  ) {
    super(router, paymentDashboardAnalytics);
  }
}
